import { EarningsInsightPreviewResponse } from '@api';
import { getTimeTillEndOfDayMs } from '@helpers';
import { useQueries, useQuery } from '@tanstack/react-query';
import {
  getEarningsInsightPreview,
  QUERY_KEY_EARNINGS_INSIGHT_PREVIEW,
} from '@terminal/services/insights/earnings-insights-service';

export const useGetEarningsInsightPreview = (earningsInsightId: string) =>
  useQuery({
    queryKey: [QUERY_KEY_EARNINGS_INSIGHT_PREVIEW, earningsInsightId],
    queryFn: ({ signal }) =>
      getEarningsInsightPreview(earningsInsightId, signal),
    staleTime: getTimeTillEndOfDayMs(),
    enabled: !!earningsInsightId,
  });

export const useEarningsInsightPreviews = (earningsInsightIds: string[]) =>
  useQueries({
    queries: earningsInsightIds.map(earningsInsightId => ({
      queryKey: [QUERY_KEY_EARNINGS_INSIGHT_PREVIEW, earningsInsightId],
      queryFn: ({ signal }: { signal?: AbortSignal }) =>
        getEarningsInsightPreview(earningsInsightId, signal),
      staleTime: getTimeTillEndOfDayMs(),
    })),
    combine: results => ({
      data: results
        .map(result => result.data)
        .filter((data): data is EarningsInsightPreviewResponse => data != null),
      isFetching: results.some(result => result.isFetching),
    }),
  });
